/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { TeamLegalEntitySummary } from './';
import {
    TeamLegalEntitySummaryFromJSON,
    TeamLegalEntitySummaryFromJSONTyped,
    TeamLegalEntitySummaryToJSON,
} from './';

/**
 * 
 * @export
 * @interface TeamLegalEntitiesResource
 */
export interface TeamLegalEntitiesResource {
    /**
     * 
     * @type {Array<TeamLegalEntitySummary>}
     * @memberof TeamLegalEntitiesResource
     */
    legalEntities: Array<TeamLegalEntitySummary>;
}

/**
 * Check if a given object implements the TeamLegalEntitiesResource interface.
 */
export function instanceOfTeamLegalEntitiesResource(value: object): value is TeamLegalEntitiesResource {
    if (!('legalEntities' in value) || value['legalEntities'] === undefined) return false;
    return true;
}

export function TeamLegalEntitiesResourceFromJSON(json: any): TeamLegalEntitiesResource {
    return TeamLegalEntitiesResourceFromJSONTyped(json, false);
}

export function TeamLegalEntitiesResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamLegalEntitiesResource {
    if (json == null) {
        return json;
    }
    return {
        
        'legalEntities': ((json['legalEntities'] as Array<any>).map(TeamLegalEntitySummaryFromJSON)),
    };
}

export function TeamLegalEntitiesResourceToJSON(value?: TeamLegalEntitiesResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'legalEntities': ((value['legalEntities'] as Array<any>).map((v) => TeamLegalEntitySummaryToJSON(v))),
    };
}

